<template>
  <div>
    <PageHeaderLayout :isBack="true">
        <div class="main-page-content" id="detail-content">
          <el-row>
            <div class="header-title">发放明细</div>
          </el-row>
          <!-- <el-row class="center">
              <el-col :span="10">
                <p class="title text-center">{{ this.baseInfo.name }}</p>
                <el-alert class="desc" type="warning" :closable="false" id="el-alert">
                  <template slot="title">
                    <div>系统提示：</div>
                    <div>1、单个批次模板数据不能超过1000条</div>
                    <div v-if="type == 'send'">2、如果需要提交数据请滑动最底部点击按钮</div>
                  </template>
                </el-alert>
              </el-col>
            </el-row> -->

            <el-row id="detail-table">
              <ApeTable ref="apeTable" :data="statusList" :columns="columnsStatus" :loading="loadingStaus" highlight-current-row >
              </ApeTable>
            </el-row>
            <el-row class="export">
              <div class="export-left">
                <el-col class="total-wrapper">
                  <div class="total-left">总笔数：</div>
                  <div class="total-right">{{this.totalNumber}}
                    <span class="total-right bi">笔</span>
                  </div>
                </el-col>
                <el-col class="total-wrapper">
                  <div class="total-left">总金额：</div>
                  <div class="total-right">{{this.totalPrice}}
                    <span class="total-right bi">元</span>
                  </div>
                </el-col>
              </div>
              <el-col class="table-right">
                <el-form style="height: 40px; line-height:40px" :inline="true">
                  <el-form-item>
                    <el-select v-model="stateValue" @change="selectState" class="select-state-box">
                      <el-option
                        v-for="item in stateOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>

                <div class="export-wrapper">
                  <el-select v-model="value" @change="selectData" class="select-box">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-button :loading="downloadLoading" type="primary" class="export-table" size="medium" icon="el-icon-document" @click="handleDownload">
                    导出
                  </el-button>
                </div>
              </el-col>
            </el-row>
            <el-row id="detail-table">
              <ApeTable ref="batchapeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
                <el-table-column
                  prop="alias_code"
                  label="银行回馈码">
                  <template slot-scope="scope">
                    <el-tag
                      :type="scope.row.alias_code === '-' ? 'info' : (scope.row.alias_code === '0000' ? 'success': 'danger')"
                    >{{scope.row.alias_code}}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="alias_msg"
                  label="银行回馈消息">
                  <template slot-scope="scope">
                    <div
                      :style="scope.row.alias_msg === '未处理' ? 'color: #909399' : (scope.row.alias_msg === '已发放' ? 'color: #67c23a': 'color: #f56c6c')"
                    >{{scope.row.alias_msg}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="alias_msg"
                  label="电子回单">
                  <template slot-scope="scope">
                    <el-button size="medium" @click="mxViewReceipt(scope.row.outer_trade_no,baseInfo.yl_bank,'',scope.row.ele_receipt_url)" type="success" plain>下载电子回单</el-button>
                  </template>
                </el-table-column>
              </ApeTable>
            </el-row>
            <el-row v-if="type == 'send'" class="center">
              <el-col class="text-center" :span="10">
                <el-button type="primary" size="medium" @click="handleSubmit">请仔细检查数据，确认无误后提交此表格</el-button>
              </el-col>
            </el-row>
        </div>
    </PageHeaderLayout>
    <verification
      @dialogChanged="dialogChanged($event)"
      @onSuccess="handleSuccess($event)"
      :dialogVisible="dialogVisible" />
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import Verification from "@/components/Verification"
import DatePicker from '@/components/DatePicker.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    Verification,
    DatePicker
  },
  data() {
    return {
      //发放状态
      stateOptions: [
        {
          value: '',
          label: '全部发放状态'
        },
        {
          value: '00',
          label: '未处理'
        },
        {
          value: '02',
          label: '发放失败'
        },
        {
          value: '11',
          label: '已发放'
        }
      ],
      stateValue: '全部发放状态',
      totalNumber: '',
      totalPrice: '',
      // idcard: '',
      dialogVisible: false,
      downloadLoading: false,
      id: 0,
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      type: '',
      tableData: [],
      tableHeader: [],
      searchCategory: [],
      taskList: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: true,
      //导出格式
      options: [{
          value: 'xlsx',
          label: 'xlsx'
        }, {
          value: 'csv',
          label: 'csv'
        }, {
          value: 'txt',
          label: 'txt'
        }
      ],
      value: 'xlsx',
      //导出表格类型
      bookType: 'xlsx',
      columnsStatus: [
        {
          title: "结算笔数",
          value: "total_num"
        },
        {
          title: "结算金额",
          value: "total_amount"
        },
        {
          title: "成功笔数",
          value: "succeed_num"
        },
        {
          title: "成功金额",
          value: "succeed_money"
        },
        {
          title: "失败笔数",
          value: "failed_num"
        },
        {
          title: "失败金额",
          value: "failed_money"
        },
      ],
      statusList: [],
      columns: [
        {
          title: "姓名",
          value: "bank_account_name"
        },
        {
          title: "收款账号",
          value: "bank_account_no"
        },
        {
          title: "下发通道",
          value: "alias_send_type",
        },
        // {
        //   title: "证件类型",
        //   value: "alias_id_type",
        // },
        // {
        //   title: "证件号码",
        //   value: "id_number",
        // },
        // {
        //   title: "手机号码",
        //   value: "mobile",
        // },
        {
          title: '附属信息',
          width: 300,
          value: [
            {label:'证件类型：',value:'alias_id_type'},
            {label:'证件号码：',value:'id_number'},
            {label:'手机号码：',value:'mobile'},
            {label: '银行名称：', value: 'bank_name'},
            {label: '编码：', value: 'code'},
            {label: '下发时间：', value: 'notify_time'}
          ],
          header_align: 'center',
        /*   align: 'center', */
        },
        {
          title: "下发金额",
          value: "money",
        },
       /*  {
          title: "银行回馈码",
          value: "alias_code",
          color: '',
          fontWeight: 'bold'
        },
        {
          title: "银行回馈消息",
          value: "alias_msg",
          color: '',
          fontWeight: 'bold'
        }, */
      ],
      idcard: '',
      // 表格列表数据
      baseInfo:{},
      dataList:[

      ],
      //导出表格数据
      exportList: [],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, prev, pager, next',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证

      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        // direction: 'right',
        title: '',
        width_height: '640px',
        show_footer:false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 附件列表
      attachmentList:[],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: '标题',
          value: 'title',
        }
      ],
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentCompanyId:0,
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  watch: {
    idcard(val) {
      this.idcard = val
    }
  },
  methods: {
    async handleSuccess() {
      const res = await this.$api.sendTask({
        batch_id: this.baseInfo.id,
      })
      if (res) {
        this.$message.success('提交成功，请等待系统审核!')
        this.goBack()
      }
    },
    //返回上一页
    goBack() {
      this.$router.push(this.$route.matched[1].path)
    },
    dialogChanged(state) {
      this.dialogVisible = state
    },
    // 表单提交
    handleSubmit() {
      if (this.dataList.length <= 0) {
        return this.$message.error('提交失败，数据不能为为空!')
      }
      this.dialogVisible = true;
    },
    //选择发放状态
    selectState(e) {
      this.searchCondition.send_status = e
      if(!this.searchCondition.send_status) {
        delete this.searchCondition.send_status
      }
      this.init('search')
    },
    //选择导出表格格式
    selectData(e) {
      this.bookType = e;
    },
    //导出表格数据
    async handleDownload() {
      this.downloadLoading = true
      import('@/excel/Export2Excel').then( excel => {
        const tHeader = ['姓名', '收款账号', '下发通道', '证件类型', '证件号码', '手机号码', '编码', '下发金额',' 下发时间', '银行回馈码', '银行回馈消息'];
        const data = this.formatJson(this.exportList)
        const time = new Date().getTime() + Math.random() * 1000
        let filename = `发放明细${time}`
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType //Optional
        })
        this.downloadLoading = false;
      })
    },
    formatJson(jsonData) {
      return jsonData.map(v =>{
        let {
          bank_account_name,
          bank_account_no,
          alias_send_type,
          alias_id_type,
          id_number,
          mobile,
          code,
          money,
          notify_time,
          alias_code,
          alias_msg,
        } = v
        return [bank_account_name, bank_account_no, alias_send_type, alias_id_type, id_number, mobile, code, money,notify_time, alias_code, alias_msg]
      })
    },
    // 初始化列表
    async init(type) {
      var _this = this
      this.id = this.$route.params.batch_id
      if (this.id) {
        this.loadingStaus = true
        let args = {
          id: this.id
        }
        let searchCondition = this.handleSearchCondition()
        Object.assign(searchCondition, args)
        let {base, detail} = await this.$api.getTaskInfo(searchCondition)
        this.baseInfo = base
        this.statusList = [base]
        this.dataList = detail
        this.totalNumber = this.dataList.length
        this.totalPrice = detail.reduce(function (total, currentValue) {
          return _this.$utils.sumTotal(total, currentValue.money)
        }, 0)
        this.exportList = detail
        let pagingInfo = this.$refs['batchapeTable'].getPagingInfo(type)
        this.pagingData.total = this.dataList.length
        this.offset += 10
        this.dataList=  this.dataList.slice(pagingInfo.current_page * 10 - 10, pagingInfo.current_page * 10)
      }
      this.loadingStaus=false
    },
    // 切换页码操作
    switchPaging() {
      this.init()
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.send_status) {
        condition.send_status = this.searchCondition.send_status
      }
      return condition
    },

    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      this.formData.company_id = this.currentCompanyId
      let id = await this.$api.saveCompanyAttachment(this.formData)
      this.$nextTick(() => {
        this.dialogClose()
      })
      this.$nextTick(() => {
        if (id) {
          this.initCompanyAttachmentList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyAttacmentForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
      this.attachmentUploadFileList = []
    }
  },
  updated() {
    this.type = this.mxGetQuery('type') || 'view'
    if(this.type != 'view') {
      this.$refs['batchapeTable'].handleCurrentChange(1)
    }
  },
  created() {
    // this.type = this.mxGetQuery('type') || 'view'
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .submitBtn
    float: right
    margin-top: 20px
  .link-url
    color: #fff
    text-decoration:none
  .title
    font-size: 32px
  .desc
    margin-bottom 30px
  .center
    display flex
    justify-content center
  .text-center
    text-align center
  .header-title
    height: 53px
    line-height: 53px
    background-color: #1890ff
    color: #fff
    font-size: 20px
    text-align: center
  #detail-content
    padding: 0;
    padding-bottom: 24px
  #detail-table
    padding: 0 24px
  .detail-search
    padding: 0 24px
    height: 50px
    padding-top: 10px
  .export
    display: flex;
    flex-direction: row;
    justify-content: flex-end
    padding: 0 15px
  .select-box
    margin-right: 10px
    width: 100px
  .select-state-box
    width: 130px
  .total-wrapper
    display: flex
    flex-direction: row
    padding: 0 10px
    margin-top: 10px
    margin-left: 15px
    width: 270px
  .total-left
    color: #606266
    font-size: 16px
    text-align: left
  .total-right
    color: red;
    font-size: 15px
  .export-left
    width: 100%
  .table-right
    display: flex
    flex-direction: row
    justify-content: flex-end
  .export-wrapper
    height:40px
    display:flex
    align-items: center
  /deep/.el-input__inner
    height:36px
    line-height: 36px
</style>
